'use client'

import { Alert, AlertDescription } from '@repo/ui'
import { motion } from 'framer-motion'

import { LiquidationTable } from '@/lib/modules/liquidations/components/table/LiquidationTable'
import { AnimatedTitle } from '@/lib/shared/components/animations/AnimatedTitle'

export default function HomePage() {
  return (
    <div className="relative mx-auto min-h-[100dvh] max-w-7xl px-4 pb-24">
      <div className="flex w-full flex-col items-center justify-center space-y-2 overflow-x-hidden py-16 md:py-24">
        <AnimatedTitle text="Liquidations" />
        <motion.h2
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.3, ease: 'easeOut' }}
          style={{
            willChange: 'opacity, transform',
            backfaceVisibility: 'hidden'
          }}
          className="text-center text-2xl font-thin"
        >
          Monitor liquidation opportunities in Morpho markets.
        </motion.h2>
      </div>
      <motion.div
        initial={{ opacity: 0, y: 10, scale: 0.98 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        transition={{
          duration: 1.3,
          ease: 'easeOut'
        }}
        className="flex flex-col gap-4"
        style={{
          willChange: 'opacity, transform, filter',
          backfaceVisibility: 'hidden'
        }}
      >
        <Alert variant="info">
          {/* `block`, because `AlertDescription` is a grid: each child — the text, the link, the
              trailing text — would otherwise be its own row, breaking one sentence across three
              lines. */}
          <AlertDescription className="block">
            Borrower positions for Vaults V2 are now in the{' '}
            <a
              href="https://curator.morpho.org"
              target="_blank"
              rel="noopener noreferrer"
              className="underline underline-offset-2"
            >
              Curator App
            </a>{' '}
            (beta), under each vault&apos;s Risk tab.
          </AlertDescription>
        </Alert>
        <LiquidationTable />
      </motion.div>
    </div>
  )
}
